import "./featuredProperties.css"

const FeaturedProperties = () => {
  return (
    < div className="fp">
     < div className="fpItem">
        <img src="https://images.unsplash.com/photo-1618773928121-c32242e63f39?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt=""
          className="fpImg" />
          <span className="fpName">Adey Hotel</span>
          <span className="fpCity">Bahir Dar</span>
          <span className="fpPrice">Starting from $100</span>
          <div className="fpRating">
            <button>8.5</button>
            <span>Excellent</span>
          </div>
          </div>
          <div className="fpItem">
        <img src="https://images.unsplash.com/photo-1611892440504-42a792e24d32?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt=""
          className="fpImg"
           />
          <span className="fpName">Sheraton Hotel</span>
          <span className="fpCity">Addis Ababa</span>
          <span className="fpPrice">Starting from $120</span>
          <div className="fpRating">
            <button>8.9</button>
            <span>Excellent</span>
          </div>
          </div>
        <div className="fpItem">
        <img src="https://images.unsplash.com/photo-1578683010236-d716f9a3f461?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"alt=""
          className="fpImg" />
          <span className="fpName">Jacaranda Hotel</span>
          <span className="fpCity">Bahir Dar</span>
          <span className="fpPrice">Starting from $115</span>
          <div className="fpRating">
            <button>8.7</button>
            <span>Excellent</span>
          </div>
          </div>
          <div className="fpItem">
        <img src="https://images.unsplash.com/photo-1600011689032-8b628b8a8747?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDR8fGhvdGVsfGVufDB8fDB8fHww" alt=""
          className="fpImg" />
          <span className="fpName">Aparthotel Stare Miasto</span>
          <span className="fpCity">Madrid</span>
          <span className="fpPrice">Starting from $120</span>
          <div className="fpRating">
            <button>8.9</button>
            <span>Excellent</span>
          </div>
       </div>
       </div>
       
  )
}

export default FeaturedProperties;